// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 실행계획 옆의 증상·사례·이력. 우측 패널 위에 얹히므로 폭이 좁다 — 표는 가로로만 스크롤한다. */
.PlanInsights_wrap__zo5xu {
  padding: 6px 8px;
  border-bottom: 1px solid var(--color-border, #e5e7eb);
  font-size: 11px;
  animation: PlanInsights_plan-insights-fade__CR7V4 160ms ease-out;
}

@keyframes PlanInsights_plan-insights-fade__CR7V4 {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: none; }
}

.PlanInsights_block__F4tdt { margin-bottom: 8px; }
.PlanInsights_block__F4tdt:last-child { margin-bottom: 0; }

.PlanInsights_title__KCiX1 {
  font-weight: 600;
  color: var(--color-text-secondary, #6b7280);
}

/* 접기/펼치기 머리 — 기본은 접힘이라 이 줄만 보인다 */
.PlanInsights_sectionToggle__NIdiJ {
  display: flex;
  align-items: center;
  gap: 3px;
  width: 100%;
  padding: 0 0 4px 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font-size: 11px;
  color: var(--color-text-secondary, #6b7280);
  transition: color 150ms ease;
}
.PlanInsights_sectionToggle__NIdiJ:hover { color: var(--color-accent, #3b82f6); }

.PlanInsights_count__sVATa {
  margin-left: auto;
  font-size: 10px;
  opacity: 0.7;
}

@media (prefers-reduced-motion: reduce) {
  .PlanInsights_sectionToggle__NIdiJ { transition: none; }
}

.PlanInsights_badges__hf378 { display: flex; flex-wrap: wrap; gap: 4px; }

.PlanInsights_badge__sU\\+SU {
  display: inline-flex; align-items: center; gap: 3px;
  padding: 1px 6px; border-radius: 9px;
  background: var(--color-warning-bg, #fef3c7);
  color: var(--color-warning-text, #92400e);
  white-space: nowrap;
}

.PlanInsights_caseItem__IsEqr { margin-bottom: 5px; }

.PlanInsights_caseHead__3MJVB {
  display: flex; align-items: center; gap: 3px;
  width: 100%; padding: 0; border: none; background: none; cursor: pointer;
  text-align: left; color: var(--color-text, #111827); font-size: 11px;
  transition: color 150ms ease;
}
.PlanInsights_caseHead__3MJVB:hover { color: var(--color-accent, #3b82f6); }

.PlanInsights_caseTitle__SEBmc { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.PlanInsights_caseMeta__NXmnM, .PlanInsights_candMeta__QO4Pw {
  color: var(--color-text-secondary, #6b7280);
  font-size: 10px;
  padding-left: 13px;
}

.PlanInsights_caseBody__fVc2i {
  margin: 3px 0 0 13px; padding: 5px 6px;
  background: var(--color-bg-secondary, #f9fafb);
  border-radius: 4px;
  white-space: pre-wrap; word-break: break-word;
  max-height: 220px; overflow: auto;
  animation: PlanInsights_plan-insights-fade__CR7V4 160ms ease-out;
}

.PlanInsights_note__NAb8U {
  color: var(--color-text-secondary, #6b7280);
  font-size: 10px; margin-top: 3px;
}

.PlanInsights_action__kbTst, .PlanInsights_candidate__RIHPP {
  display: block; width: 100%; text-align: left;
  padding: 3px 6px; margin-bottom: 3px;
  border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px;
  background: var(--color-bg, #fff); color: var(--color-text, #111827);
  font-size: 11px; cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.PlanInsights_action__kbTst { display: inline-flex; align-items: center; gap: 4px; width: auto; }
.PlanInsights_action__kbTst:hover, .PlanInsights_candidate__RIHPP:hover { border-color: var(--color-accent, #3b82f6); }
.PlanInsights_action__kbTst:disabled { cursor: default; opacity: 0.6; }

.PlanInsights_candHead__qNPFe {
  display: block; font-family: monospace; font-size: 10px;
  color: var(--color-text-secondary, #6b7280);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.PlanInsights_hist__KueoZ { margin-top: 4px; }
.PlanInsights_histLine__fYv4k { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-bottom: 4px; }

.PlanInsights_warn__K1lAu {
  display: inline-flex; align-items: center; gap: 3px;
  color: var(--color-warning-text, #92400e);
  background: var(--color-warning-bg, #fef3c7);
  padding: 1px 5px; border-radius: 9px;
}

/* 좁은 패널이라 표는 자기 안에서만 가로 스크롤한다 — 본문이 밀리면 안 된다 */
.PlanInsights_histTable__MRPw7 {
  display: block; overflow-x: auto; white-space: nowrap;
  width: 100%; border-collapse: collapse; font-size: 10px;
}
.PlanInsights_histTable__MRPw7 th, .PlanInsights_histTable__MRPw7 td {
  padding: 2px 5px; text-align: right;
  border-bottom: 1px solid var(--color-border, #e5e7eb);
}
.PlanInsights_histTable__MRPw7 th:first-child, .PlanInsights_histTable__MRPw7 td:first-child { text-align: left; }
.PlanInsights_histTable__MRPw7 th { color: var(--color-text-secondary, #6b7280); font-weight: 600; }

.PlanInsights_events__J-LpP { margin-top: 4px; }
.PlanInsights_event__wJwvq { display: flex; justify-content: space-between; gap: 6px; padding: 1px 0; }
.PlanInsights_event__wJwvq > span:first-child { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

[data-theme="dark"] .PlanInsights_badge__sU\\+SU,
[data-theme="dark"] .PlanInsights_warn__K1lAu { background: #78350f; color: #fde68a; }
[data-theme="dark"] .PlanInsights_caseBody__fVc2i { background: var(--color-bg-secondary, #2d2d2d); }
[data-theme="dark"] .PlanInsights_action__kbTst,
[data-theme="dark"] .PlanInsights_candidate__RIHPP { background: var(--color-input-bg, #3c3c3c); }

@media (prefers-reduced-motion: reduce) {
  .PlanInsights_wrap__zo5xu, .PlanInsights_caseBody__fVc2i { animation: none; }
  .PlanInsights_caseHead__3MJVB, .PlanInsights_action__kbTst, .PlanInsights_candidate__RIHPP { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/assistant/PlanInsights.module.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,qDAAqD;EACrD,eAAe;EACf,gEAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA,6BAAS,kBAAkB,EAAE;AAC7B,wCAAoB,gBAAgB,EAAE;;AAEtC;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA,2CAAuB,mCAAmC,EAAE;;AAE5D;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAiB,gBAAgB,EAAE;AACrC;;AAEA,8BAAU,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;;AAEpD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,gBAAgB,EAAE,kBAAkB;EACpC,4CAA4C;EAC5C,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,gCAAY,kBAAkB,EAAE;;AAEhC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE,gBAAgB,EAAE,eAAe;EACxE,gBAAgB,EAAE,iCAAiC,EAAE,eAAe;EACpE,4BAA4B;AAC9B;AACA,sCAAkB,mCAAmC,EAAE;;AAEvD,iCAAa,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE7E;EACE,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,EAAE,gBAAgB;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,qBAAqB,EAAE,sBAAsB;EAC7C,iBAAiB,EAAE,cAAc;EACjC,gEAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,eAAe,EAAE,eAAe;AAClC;;AAEA;EACE,cAAc,EAAE,WAAW,EAAE,gBAAgB;EAC7C,gBAAgB,EAAE,kBAAkB;EACpC,8CAA8C,EAAE,kBAAkB;EAClE,iCAAiC,EAAE,iCAAiC;EACpE,eAAe,EAAE,eAAe;EAChC,gEAAgE;AAClE;AACA,8BAAU,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW,EAAE;AAC5E,0EAAkC,0CAA0C,EAAE;AAC9E,uCAAmB,eAAe,EAAE,YAAY,EAAE;;AAElD;EACE,cAAc,EAAE,sBAAsB,EAAE,eAAe;EACvD,2CAA2C;EAC3C,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA,4BAAQ,eAAe,EAAE;AACzB,gCAAY,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAE/F;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,yCAAyC;EACzC,4CAA4C;EAC5C,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA,+CAA+C;AAC/C;EACE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB;EACrD,WAAW,EAAE,yBAAyB,EAAE,eAAe;AACzD;AACA;EACE,gBAAgB,EAAE,iBAAiB;EACnC,qDAAqD;AACvD;AACA,+FAAuD,gBAAgB,EAAE;AACzE,oCAAgB,2CAA2C,EAAE,gBAAgB,EAAE;;AAE/E,8BAAU,eAAe,EAAE;AAC3B,6BAAS,aAAa,EAAE,8BAA8B,EAAE,QAAQ,EAAE,cAAc,EAAE;AAClF,gDAA4B,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE5F;gDAC4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,oDAAgC,8CAA8C,EAAE;AAChF;qDACiC,0CAA0C,EAAE;;AAE7E;EACE,2DAAmB,eAAe,EAAE;EACpC,6FAAiC,gBAAgB,EAAE;AACrD","sourcesContent":["/* 실행계획 옆의 증상·사례·이력. 우측 패널 위에 얹히므로 폭이 좁다 — 표는 가로로만 스크롤한다. */\n.wrap {\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--color-border, #e5e7eb);\n  font-size: 11px;\n  animation: plan-insights-fade 160ms ease-out;\n}\n\n@keyframes plan-insights-fade {\n  from { opacity: 0; transform: translateY(-3px); }\n  to   { opacity: 1; transform: none; }\n}\n\n.block { margin-bottom: 8px; }\n.block:last-child { margin-bottom: 0; }\n\n.title {\n  font-weight: 600;\n  color: var(--color-text-secondary, #6b7280);\n}\n\n/* 접기/펼치기 머리 — 기본은 접힘이라 이 줄만 보인다 */\n.sectionToggle {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  width: 100%;\n  padding: 0 0 4px 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: 11px;\n  color: var(--color-text-secondary, #6b7280);\n  transition: color 150ms ease;\n}\n.sectionToggle:hover { color: var(--color-accent, #3b82f6); }\n\n.count {\n  margin-left: auto;\n  font-size: 10px;\n  opacity: 0.7;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sectionToggle { transition: none; }\n}\n\n.badges { display: flex; flex-wrap: wrap; gap: 4px; }\n\n.badge {\n  display: inline-flex; align-items: center; gap: 3px;\n  padding: 1px 6px; border-radius: 9px;\n  background: var(--color-warning-bg, #fef3c7);\n  color: var(--color-warning-text, #92400e);\n  white-space: nowrap;\n}\n\n.caseItem { margin-bottom: 5px; }\n\n.caseHead {\n  display: flex; align-items: center; gap: 3px;\n  width: 100%; padding: 0; border: none; background: none; cursor: pointer;\n  text-align: left; color: var(--color-text, #111827); font-size: 11px;\n  transition: color 150ms ease;\n}\n.caseHead:hover { color: var(--color-accent, #3b82f6); }\n\n.caseTitle { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.caseMeta, .candMeta {\n  color: var(--color-text-secondary, #6b7280);\n  font-size: 10px;\n  padding-left: 13px;\n}\n\n.caseBody {\n  margin: 3px 0 0 13px; padding: 5px 6px;\n  background: var(--color-bg-secondary, #f9fafb);\n  border-radius: 4px;\n  white-space: pre-wrap; word-break: break-word;\n  max-height: 220px; overflow: auto;\n  animation: plan-insights-fade 160ms ease-out;\n}\n\n.note {\n  color: var(--color-text-secondary, #6b7280);\n  font-size: 10px; margin-top: 3px;\n}\n\n.action, .candidate {\n  display: block; width: 100%; text-align: left;\n  padding: 3px 6px; margin-bottom: 3px;\n  border: 1px solid var(--color-border, #e5e7eb); border-radius: 4px;\n  background: var(--color-bg, #fff); color: var(--color-text, #111827);\n  font-size: 11px; cursor: pointer;\n  transition: background-color 150ms ease, border-color 150ms ease;\n}\n.action { display: inline-flex; align-items: center; gap: 4px; width: auto; }\n.action:hover, .candidate:hover { border-color: var(--color-accent, #3b82f6); }\n.action:disabled { cursor: default; opacity: 0.6; }\n\n.candHead {\n  display: block; font-family: monospace; font-size: 10px;\n  color: var(--color-text-secondary, #6b7280);\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n.hist { margin-top: 4px; }\n.histLine { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-bottom: 4px; }\n\n.warn {\n  display: inline-flex; align-items: center; gap: 3px;\n  color: var(--color-warning-text, #92400e);\n  background: var(--color-warning-bg, #fef3c7);\n  padding: 1px 5px; border-radius: 9px;\n}\n\n/* 좁은 패널이라 표는 자기 안에서만 가로 스크롤한다 — 본문이 밀리면 안 된다 */\n.histTable {\n  display: block; overflow-x: auto; white-space: nowrap;\n  width: 100%; border-collapse: collapse; font-size: 10px;\n}\n.histTable th, .histTable td {\n  padding: 2px 5px; text-align: right;\n  border-bottom: 1px solid var(--color-border, #e5e7eb);\n}\n.histTable th:first-child, .histTable td:first-child { text-align: left; }\n.histTable th { color: var(--color-text-secondary, #6b7280); font-weight: 600; }\n\n.events { margin-top: 4px; }\n.event { display: flex; justify-content: space-between; gap: 6px; padding: 1px 0; }\n.event > span:first-child { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n[data-theme=\"dark\"] .badge,\n[data-theme=\"dark\"] .warn { background: #78350f; color: #fde68a; }\n[data-theme=\"dark\"] .caseBody { background: var(--color-bg-secondary, #2d2d2d); }\n[data-theme=\"dark\"] .action,\n[data-theme=\"dark\"] .candidate { background: var(--color-input-bg, #3c3c3c); }\n\n@media (prefers-reduced-motion: reduce) {\n  .wrap, .caseBody { animation: none; }\n  .caseHead, .action, .candidate { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `PlanInsights_wrap__zo5xu`,
	"plan-insights-fade": `PlanInsights_plan-insights-fade__CR7V4`,
	"block": `PlanInsights_block__F4tdt`,
	"title": `PlanInsights_title__KCiX1`,
	"sectionToggle": `PlanInsights_sectionToggle__NIdiJ`,
	"count": `PlanInsights_count__sVATa`,
	"badges": `PlanInsights_badges__hf378`,
	"badge": `PlanInsights_badge__sU+SU`,
	"caseItem": `PlanInsights_caseItem__IsEqr`,
	"caseHead": `PlanInsights_caseHead__3MJVB`,
	"caseTitle": `PlanInsights_caseTitle__SEBmc`,
	"caseMeta": `PlanInsights_caseMeta__NXmnM`,
	"candMeta": `PlanInsights_candMeta__QO4Pw`,
	"caseBody": `PlanInsights_caseBody__fVc2i`,
	"note": `PlanInsights_note__NAb8U`,
	"action": `PlanInsights_action__kbTst`,
	"candidate": `PlanInsights_candidate__RIHPP`,
	"candHead": `PlanInsights_candHead__qNPFe`,
	"hist": `PlanInsights_hist__KueoZ`,
	"histLine": `PlanInsights_histLine__fYv4k`,
	"warn": `PlanInsights_warn__K1lAu`,
	"histTable": `PlanInsights_histTable__MRPw7`,
	"events": `PlanInsights_events__J-LpP`,
	"event": `PlanInsights_event__wJwvq`
};
export default ___CSS_LOADER_EXPORT___;
